import { createReducer, on } from '@ngrx/store';
import { Theme } from 'studio-components';
import { DesignerViewActions } from '../designer/view/designer-view.actions';

export interface UIState {
  theme: Theme;
}

export const initialState: UIState = {
  theme: 'light',
};

export const uiReducer = createReducer(
  initialState,
  on(DesignerViewActions.designerEntered, (state) => ({
    ...state,
    theme: 'dark' as const,
  })),
  on(DesignerViewActions.designerExited, (state) => ({
    ...state,
    theme: 'light' as const,
  })),
);
